module.exports = __webpack_public_path__ + "static/media/services_health.4b0717fe.jpg";